import React, { FC, ReactElement } from 'react';

import { PlansPageBody } from 'components';

import { PLAN_ACTIONS } from 'constants/plansItems';

export const OrderPlanPageSecond: FC = (): ReactElement => <PlansPageBody type={PLAN_ACTIONS.CREATING} />;
